import { Injectable, inject } from '@angular/core';


import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom, map } from 'rxjs/operators';

import * as fromStore from '../store';
import * as fromRoot from '../../store';
import { Observable, of } from 'rxjs';
import { ResetTheme, SetTheme } from '../../store';
import { getCurrentTheme } from '../../store/selectors/theme.selector';
import { DiseaseProfileComponent } from '../containers/disease-profile/disease-profile.component';

@Injectable({ providedIn: 'root' })
export class ThemeResetGuard  {
  private store = inject<Store<fromStore.DiseaseProfileState>>(Store);


  canDeactivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(getCurrentTheme).pipe(
      tap(theme => {
        if (theme) {
          this.store.dispatch(SetTheme({ theme: 'standard' }));
        }
      }),
      map(theme => !theme),
      take(1)
    );
  }
}
